<template>
  <div class="pages">
    <!--    导航-->
    <shortcut></shortcut>
    <!--    头部-->
    <commonHeader v-if="update" :selectCode="8"></commonHeader>
    <!--    内容-->
    <div class="content">
      <div class="banner" v-if="dataList.length > 0">
        <carousel :defaultList="dataList"
                  width="1200px"
                  height="200px"></carousel>
<!--        <img src="/static/img/cameraLens.png" alt="">-->
      </div>
      <div class="classify user-select">
        <div class="classify-item" v-if="brand.length > 0">
          <div class="classify-item-label">
            <p>{{ $t('品牌') }}</p>
          </div>
          <div class="classify-item-content">
            <div v-for="(item,index) in brand" :key="index">
              <p :class=" item.checked && 'active' " @click="!item.checked && changeClassify(item.id, 'brand','classify')">{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="classify-item" v-for="(item,index) in classify" :key="index">
          <div class="classify-item-label">
            <p>{{ $t('分类') }}</p>
          </div>
          <div class="classify-item-content">
            <div v-for="(itemC,indexC) in item.children" :key="indexC">
              <p :class="itemC.checked && 'active' " @click="!itemC.checked && changeClassify(itemC.id, 'classify', 'classify', index)">{{ itemC.name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        @click="() => { this.$router.push({ name: 'allProducts', params: { pid: '', title: '', name: '', topid: '' } }) }">
        <el-empty description=" "
                  image="/static/kong.png"
                  style="margin: 0 auto"
                  v-if="goodsData.length === 0"
                  :image-size="550" />
      </div>
      <div class="goods">
        <div class="goods-item" v-for="(item,index) in goodsData" :key="index">
          <div class="goods-item-content">
            <div class="goods-item-content-image" @click="getId(item)">
              <img :src="$jx.oss(item.image)" alt="">
            </div>
            <div class="goods-item-content-info">
              <div class="goods-item-content-info-name" @click="getId(item)">{{ item.title }}</div>
              <div class="goods-item-content-info-footer user-select" @click="getId(item)">
                <div class="goods-item-content-info-footer-num">
                  <div v-for="(itemC,indexC) in item.goods_sku" :key="indexC">
                    <p>{{ itemC.num }}</p>
                    <p>+:￥{{ itemC.price }}</p>
                  </div>
                </div>
              </div>
              <div class="goods-item-content-info-footer user-select">
                <div class="goods-item-content-info-footer-num">
                  <el-input-number size="small"
                                   :min="0"
                                   :max="item.stock_num"
                                   v-model="item.GMnum"></el-input-number>
                </div>
                <div class="goods-item-content-info-footer-operate" @click="addCar(item)">加入购物车</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination background
                     v-if="total > 0"
                     @current-change="goPage"
                     :page-size="per_page"
                     layout="prev, pager, next,jumper"
                     :total=total>
      </el-pagination>
    </div>

    <!--    底部-->
    <foot style="padding-top: 15px;"></foot>
  </div>
</template>

<script>
import shortcut from '@/components/shortcut/shortcut.vue';
import foot from '@/components/footer/footer.vue';
import carousel from '@/components/carousel/carousel.vue';
export default {
  name: "index",
  components: {
    shortcut,
    foot,
    carousel
  },
  data () {
    return {
      update: true,
      dataList: [], // 轮播图
      classifyId: 1606,
      pid: 1606,
      brand: [], // 品牌
      classify: [], // 分类
      ability: [], // 能力

      goodsData: [],
      total: 0,
      per_page: 15,
    }
  },
  async created () {
    this.getbanner()

    // await this.getCate(this.classifyId, 'brand', null)
    this.brand = await this.getCateOld(this.classifyId, 'brand', null)
    if(this.brand && this.brand.length > 0){
      this.brand[0].checked = true
      this.classify = await this.getCateOldTwo(this.brand[0].id, 'classify', 0)
      if(this.classify && this.classify.length > 0){
        this.classify = await this.getCateOldTwo(this.classify[0].children[0].id, 'classify', 0)
      }
      // await this.getCate(this.brand[0].id, 'classify', 0)
    }
    this.getList(1,this.classifyId)
  },
  methods: {
    // 跳转分页
    goPage (val) {
      this.getList(val,this.pid)
      this.$nextTick(() => {
        window.scroll(0, 0);
      })
    },
    // 加入购物车
    addCar (v) {
      this.$jx.IsToken().then((res) => {
        if (res) {
          if (v.GMnum > 0) {
            if (v.is_link == 1) {
              let common = JSON.parse(localStorage.getItem('jx:common')).data
              window.open(`http://wpa.qq.com/msgrd?v=1&uin=${common.web_qq}&site=qq&menu=yes`)
              return
            }
            this.$http.post("/wanlshop/cart/storage", {
              type: "add",
              "data": {
                "price": v.skuprice,//现价
                "market": v.skumarket_price,//市场价
                "shop_id": v.shop_id,
                "shop_name": v.shopname,
                "goods_id": v.id,
                "title": v.title,
                "number": v.GMnum,
                "image": v.image,
                "sku": {
                  "id": v.skuid,
                  "price": v.skuprice,
                  "market_price": v.skumarket_price,
                  "stock": v.stock,
                  "state": v.state,
                  "weigh": v.weigh,
                  "sn": "0000",
                  "sales": v.sales,
                },
                "sku_id": v.goods_sku && v.goods_sku[0].id,
                "sum": 144
              },

            }).then(res => {
                this.$jx.open1(res.msg)
                this.Carshow = true
                // 移除组件
                this.update = false
                // 在组件移除后，重新渲染组件
                // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                this.$nextTick(() => {
                  this.update = true
                })
              },
              err => {
                console.log(err)
              })
          } else {
            this.$jx.open1('请先选择购买数量')
          }
        } else {
          this.$router.push({ path: '/login/signIn' });
        }
      })
    },
    //  详情
    getId (data) {
      if (data.goodstype != 1 && data.goodstype != 6) {
        data = JSON.stringify({ id: data.id })
        let routeData = this.$router.resolve({
          path: `/main/goods/${data}`,
          query: data
        })
        window.open(routeData.href, '_blank')
      }
      if (data.goodstype == 1) {
        this.$router.push({ name: 'seckill' })
      }
      if (data.goodstype == 6) {
        this.$router.push({ name: 'jifeng' })
      }
    },
    getList(page,pid = null) {
      const params = {
        page: page,
        pid: pid,
      }
      this.$http.get("/wanlshop/product/lists_moju", params).then(res => {
        // console.log(res)
        this.goodsData = res.data.data.map(item => {
          return {
            ...item,
            GMnum: 0
          }
        })
        this.total = res.data.total
        this.per_page = res.data.per_page
      })
    },
    async changeClassify(id, key1, key2, index) {
      this.pid = id
      if (key1 === key2){
        this[key1][index].children.forEach(item => {
          item.checked = item.id === id
        })
        await this.getList(1,id)
      }else{
        this[key1].forEach(item => {
          item.checked = item.id === id
        })
        this.classify = []
        await this.getList(1,id)
      }
      key2 && this.getCate(id, key2, index)
    },
    // 请求分类
    getCate (id, key, index) {
      this.$http.get("/wanlshop/Selfsupport/getchild", {
        id: id
      }).then(res => {
        // console.log(res)
        if (res.code !== 1 || res.data.length === 0) return
        if(key === 'classify'){
          const data = res.data.map(item => {
            return {
              ...item,
              checked: false
            }
          })
          if (this[key].length === 0) {
            this[key] = [{ children: data }]
          } else {
            // 判断index是否是最后一个
            if (index === this[key].length - 1) {
              this[key].push({ children: data })
            } else {
              this[key][index + 1].children = data
            }
          }
        }else{
          this[key] = res.data.map(item => {
            return {
              ...item,
              checked: false
            }
          })
        }
      })
    },
    // 获取轮博图
    getbanner () {
      this.$http.get("/wanlshop/banner/getbanner", {
        lunbo_cate: 2
      }).then(res => {
          this.dataList = res.data
        },
        err => {
        })
    },
    getCateOld (id, key, index) {
      return new Promise(resolve => {
        this.$http.get("/wanlshop/Selfsupport/getchild", {
          id: id
        }).then(res => {
          if (res.code !== 1 || res.data.length === 0) return
          resolve(res.data.map((item,index) => {
            return {
              ...item,
              checked: index === 0
            }
          }))
        })
      })
    },
    getCateOldTwo (id, key, index) {
      return new Promise(resolve => {
        this.$http.get("/wanlshop/Selfsupport/getchild", {
          id: id
        }).then(res => {
          if (res.code !== 1 || res.data.length === 0) return
          const data = res.data.map(item => {
            return {
              ...item,
              checked: false
            }
          })
          if (this[key].length === 0) {
            this[key] = [{ children: data }]
          } else {
            // 判断index是否是最后一个
            if (index === this[key].length - 1) {
              this[key].push({ children: data })
            } else {
              this[key][index + 1].children = data
            }
          }
          resolve(this[key])
        })
      })
    },
  }
}
</script>

<style scoped lang="scss">
.pages{
  background: #f5f5f5;
}
.el-pagination {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 20px;
}
.content{
  max-width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  padding-top: 32px;
  .banner{
    width: 100%;
    height: 200px;
    background: #ffffff;
    margin-bottom: 29px;
  }
  .classify{
    width: 100%;
    border: 1px solid #666666;
    &-item{
      border-bottom: 1px solid #666666;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      background: #0094e6;
      &:last-child{
        border-bottom: none;
      }
      &-label{
        width: 120px;
        p{
          color: #ffffff;
          font-size: 18px;
          text-align: center;
          line-height: 50px;
          cursor: pointer;
        }
      }
      &-content{
        width: calc(100% - 120px);
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-left: 1px solid #666666;
        box-sizing: border-box;
        background: #FFFFFF;
        div{
          width: calc(100% / 6);
          display: flex;
          align-items: center;
          justify-content: center;
          p{
            color: #333333;
            font-size: 16px;
            line-height: 50px;
            cursor: pointer;
          }
          .active{
            color: #0094e6 !important;
          }
        }
      }
    }
  }
  .goods{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 80px 0 30px;
    &-item{
      width: calc(100% / 4);
      margin-bottom: 50px;
      &-content{
        width: 250px;
        height: 100%;
        background: #ffffff;
        margin: 0 auto;
        cursor: pointer;
        &-image{
          width: 100%;
          height: 220px;
          background: #FFFFFF;
          img{
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        &-info{
          padding: 8px 16px;
          box-sizing: border-box;
          &-name{
            width: 100%;
            font-size: 14px;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &-footer{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: 8px;
            &-num{
              div{
                display: flex;
                align-items: center;
                p{
                  font-size: 10px;
                  color: #000000;
                  line-height: 20px;
                  &:first-child{
                    width: 40px;
                  }
                }
              }
            }
            &-operate{
              width: 80px;
              font-size: 11px;
              color: #ffffff;
              line-height: 28px;
              border-radius: 6px;
              text-align: center;
              background: #0292e8;
            }
          }
        }
      }
    }
  }
}
.user-select{
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/views/lensMod/index.vue